<app-description-full *ngIf="isDesktop || isTablet"></app-description-full>
<app-description-mobile *ngIf="isMobile"></app-description-mobile>